
import * as storyblokRuntime$KmoaplCaBLfBjZUr_45husqQ7QbF3ND7qk2E1yJrbFO1E from '/codebuild/output/src2588025132/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$TvqIPfMtMhbGFzmB4RoCpjhmn4wcaACrQOxRgo_45NDsc from '/codebuild/output/src2588025132/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$KmoaplCaBLfBjZUr_45husqQ7QbF3ND7qk2E1yJrbFO1E, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipx']: { provider: ipxRuntime$TvqIPfMtMhbGFzmB4RoCpjhmn4wcaACrQOxRgo_45NDsc, defaults: {} }
}
        